import { heroImage } from '../data/copy'
import {
  HERO_SIZES,
  HERO_WIDTHS,
  IMAGE_PROXY_ORIGIN,
  optimizedImage,
  optimizedSrcSet,
} from './image'

const TITLE =
  'Yoga Kit Pro™ | Pianifica la tua lezione di yoga in meno di 10 minuti'
const DESCRIPTION =
  '70+ lezioni pronte in 6 volumi e 5 bonus strategici per insegnanti di yoga. Pianifica la tua prossima lezione in meno di 10 minuti.'

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  )
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.content = content
}

function appendLink(attrs: Record<string, string>): HTMLLinkElement {
  const link = document.createElement('link')
  Object.entries(attrs).forEach(([key, value]) => link.setAttribute(key, value))
  document.head.appendChild(link)
  return link
}

/**
 * Prepara el <head> antes del primer render:
 *
 * - idioma, título y metadatos sociales (SEO / compartir);
 * - precarga de la imagen del hero, que es el elemento LCP.
 *
 * La tipografía usa las pilas del sistema del design system (sans / serif),
 * así que no hay fuentes web que descargar.
 */
export function setupHead(): void {
  if (typeof document === 'undefined') return

  document.documentElement.lang = 'it'
  document.title = TITLE

  upsertMeta('name', 'description', DESCRIPTION)
  // --color-canvas, el fondo de la página
  upsertMeta('name', 'theme-color', '#fbf4f1')
  upsertMeta('property', 'og:type', 'website')
  upsertMeta('property', 'og:title', TITLE)
  upsertMeta('property', 'og:description', DESCRIPTION)
  upsertMeta('property', 'og:image', heroImage)
  upsertMeta('name', 'twitter:card', 'summary_large_image')
  upsertMeta('name', 'twitter:title', TITLE)
  upsertMeta('name', 'twitter:description', DESCRIPTION)
  upsertMeta('name', 'twitter:image', heroImage)

  if (document.head.querySelector('link[data-mp-head]')) return

  // Conexión anticipada al CDN de imágenes: ahorra DNS + TLS antes del LCP.
  appendLink({
    rel: 'preconnect',
    href: IMAGE_PROXY_ORIGIN,
    'data-mp-head': 'cdn',
  })

  // La imagen del hero es el LCP: empieza a descargarse antes de que React
  // monte, con el mismo srcset/sizes que el <img> para no descargarla dos veces.
  appendLink({
    rel: 'preload',
    as: 'image',
    href: optimizedImage(heroImage, 800),
    imagesrcset: optimizedSrcSet(heroImage, HERO_WIDTHS),
    imagesizes: HERO_SIZES,
    fetchpriority: 'high',
    'data-mp-head': 'hero',
  })
  // Sin fuentes web: la tipografía usa fuentes del sistema (ver tailwind.config.js),
  // así no hay CSS de Google Fonts bloqueando el primer render ni ~70 KiB de woff2.
}
